import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48b75c89"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mainContainer" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "card__form__button"
  }, [
    /*#__PURE__*/_createElementVNode("span", null, "Ingresar")
  ])
], -1))
const _hoisted_5 = { class: "card__form__link" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalCharging = _resolveComponent("ModalCharging")!
  const _component_ResetPassword = _resolveComponent("ResetPassword")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ModalCharging, { open: _ctx.openChargeModal }, null, 8, ["open"]),
    _createVNode(_component_ModalComponent, {
      open: _ctx.openResetModal,
      onCloseModal: _ctx.closeResetModal
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ResetPassword)
      ]),
      _: 1
    }, 8, ["open", "onCloseModal"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("img", {
          class: "card__image",
          src: _ctx.userImg,
          alt: ""
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.authenticateUser && _ctx.authenticateUser(...args)), ["prevent"])),
        class: "card__form"
      }, [
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("input", {
            class: "card__form__input",
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
            placeholder: "Usuario"
          }, null, 512), [
            [_vModelText, _ctx.username]
          ])
        ]),
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("input", {
            class: "card__form__input",
            type: "password",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
            placeholder: "Contraseña"
          }, null, 512), [
            [_vModelText, _ctx.password]
          ])
        ]),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openResetPassword && _ctx.openResetPassword(...args)))
          }, "Olvidaste tu contraseña?")
        ])
      ], 32)
    ])
  ]))
}